import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { remove } from "lodash";
import overlayFactory from "react-bootstrap-table2-overlay";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { columns } from "../utls/archiveUtils";

class ArchiveTable extends React.Component {
  handleNodata = () =><span className="null-message-info">No Data</span>;

  render() {
    const selectRow = {
      mode: "checkbox",
      onSelect: (row, isSelect) => {
        if (isSelect) {
          this.props.change("selectedContents", [...this.props.selectedContents, row]);
        } else {
          const { selectedContents } = this.props;
          remove(selectedContents, { id: row.id });
          this.props.change("selectedContents", selectedContents);
        }
      },
      onSelectAll: (isSelect, rows) => {
        if (isSelect) {
          this.props.change("selectedContents", [...rows]);
        } else {
          this.props.change("selectedContents", []);
        }
      }
    };
    return (
      <div style={{ paddingBottom: "10px", overflowX: "auto" }}>
        <Field component="input" name="selectedContents" hidden />
        <BootstrapTable
          classes="contentReactTable"
          ref={this.props.forwardRef}
          bordered={false}
          keyField="id"
          loading={this.props.isLoading}
          overlay={overlayFactory({
            spinner: true,
            styles: {
              overlay: base => ({
                ...base,
                width: "1412px",
                background: "rgba(221,221,221,0.3)"
              }),
              spinner: base => ({
                ...base,
                "& svg circle": {
                  stroke: "rgba(0, 193, 222)",
                  strokeWidth: "4"
                }
              })
            }
          })}
          data={this.props.archivedContentList}
          columns={columns(
            this.props.roles,
            this.props.permission,
            this.props.handleDelete,
            this.props.handleUnArchiveItem,
            this.props.handleSort,
            this.props.sortOrder
          )}
          noDataIndication={() =>
            this.props.isLoading ? <span style={{ minHeight: "100px" }} /> : <span>No data</span>
          }
          selectRow={selectRow}
        />
      </div>
    );
  }
}

// export default ContentTable;
export default connect(state => {
  const selector = formValueSelector("SelectedContentsOnArchive");
  return {
    selectedContents: selector(state, "selectedContents") || []
  };
})(
  reduxForm({
    form: "SelectedContentsOnArchive"
  })(ArchiveTable)
);
